// ======================================================================
// File Name       : ContentQuestionDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form, Table } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { CONVERT_STATUS, ANSWER_FORMULA_NUM, ANSWER_FORMULA } from '../../constants/ContentConstant';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import { getItemBoxName, htmlEntities } from '../../utils/index';
import { setDataSingleQuestion } from '../../utils/ContentUtils';
import ContentSingleQuestionAnswerList from '../content/ContentSingleQuestionAnswerList';
import TableHead from '../../components/TableHead';
import { CONTENT_QUESTION_DETAIL_PREVIEW } from '../../constants/PathConstants';
import { checkPreviewDetailQuestionPath } from '../../utils/ContentQuestionUtils';

const ContentQuestionDetail = ({
  questionKind,
  questionSecernId,
  questionTitle,
  questionContent,
  questionUseForm,
  answerFormula,
  optionMarkKind,
  inputLimitType,
  inputLimit,
  optionRandomUse,
  correctAnswer,
  correctNumber,
  optionArray,
  subQuestionArray,
  questionViewDirection,
  absolutePoint,
  limitTime,
  sankakuUseDistinct,
  onBackBtnClick,
  onDeleteBtnClick,
  link,
  isDetail,
  dataAffiliationType,
  convertStatus,
  convertErrorMessage,
  canAccess,
  questionZipFileName,
  showBackBtn,
  explanationUse,
  explanationHtmlUse,
  explanationContent,
  explanationZipFileName,
  hintUse,
  hintHtmlUse,
  hintContent,
  hintZipFileName,
  answerInfo,
  isShowConfirm,
  questionAttributeList,
}) => {
  const arrayOptionMarkKind = [
    '設定しない',
    '1/2/3/・・・',
    '①/②/③/・・・',
    'A/B/C/・・・',
    'A/B/C/・・・（丸付き）',
    'a/b/c/・・・',
    'a/b/c/・・・（丸付き）',
    'ア/イ/ウ/・・・',
    'ア/イ/ウ/・・・（丸付き）',
    'あ/い/う/・・・',
    'あ/い/う/・・・（丸付き）',
  ];
  const arrayViewDirection = ['横書き', '縦書き'];
  const arrayUseDistinct = ['使用しない', '使用する'];
  const arraySubAnswerFormula = [
    '選択式単一解答',
    '選択式複数解答',
    '選択式並べ替え解答',
    '記述式単一解答',
    '記述式単一解答（複数正答）',
    '記述式複数解答（順不同）',
    '記述式複数解答（順序指定）',
    '記述式単一解答(長文解答)',
  ];
  const thead = [
    { title: '問題属性名（問題属性ID）', width: 220, sortBy: null },
    { title: '個別問題属性名（個別問題属性ID）', sortBy: null },
  ];
  const arrayQuestionAttribute = questionAttributeList;
  const titleQuestionKind = getItemBoxName(SELECT_BOX_DATA.QUESTION_TYPE, questionKind);
  let ForEachArrayData = null;
  let valueAnswerFormula = null;
  let valueOptionMarkKind = null;
  let titleOptionMarkKind = null;
  let valueOptionRandomUse = null;
  let titleOptionRandomUse = null;
  let valueQuestionTitle = null; // #6818
  let valueQuestionContent = null;
  let valueExplanationContent = null;
  let valueHintContent = null;
  let isQuestionUseForm = false;
  let isFormulaSelectiveType = false;
  let showQuestionAttributes = null;
  const isPreview = checkPreviewDetailQuestionPath(CONTENT_QUESTION_DETAIL_PREVIEW);
  showQuestionAttributes = arrayQuestionAttribute && arrayQuestionAttribute.length > 0 &&
  arrayQuestionAttribute.map((questionAttribute, index) => (
    <tr key={index}>
      <td>
        {questionAttribute.questionAttributeName}&nbsp;({questionAttribute.questionAttributeId})
      </td>
      <td>
        {questionAttribute.eachQuestionAttributeName}&nbsp;({questionAttribute.eachQuestionAttributeId})
      </td>
    </tr>
  ));
  valueQuestionTitle = htmlEntities(questionTitle); // #6818
  if (questionUseForm == 0) {
    valueQuestionContent = htmlEntities(questionContent) || '';
  } else if (questionUseForm == 1) {
    isQuestionUseForm = true;
    valueQuestionContent = questionZipFileName ? `[HTML利用] ${questionZipFileName}` : '';
  }
  if (hintUse == 1) {
    if (hintHtmlUse == 0) {
      valueHintContent = htmlEntities(hintContent) || '';
    } else if (hintHtmlUse == 1) {
      valueHintContent = hintZipFileName ? `[HTML利用] ${hintZipFileName}` : '';
    }
  }
  if (explanationUse == 1) {
    if (explanationHtmlUse == 0) {
      valueExplanationContent = htmlEntities(explanationContent) || '';
    } else if (explanationHtmlUse == 1) {
      valueExplanationContent = explanationZipFileName ? `[HTML利用] ${explanationZipFileName}` : '';
    }
  }
  // check question kind is single or big question to show question info
  if (questionKind == 0) {
    if (answerFormula !== undefined) {
      valueAnswerFormula = arraySubAnswerFormula[answerFormula];
    }
    if (answerFormula < ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER) {
      titleOptionMarkKind = '選択肢記号種別';
      titleOptionRandomUse = '選択肢ランダム設定';
      valueOptionMarkKind = arrayOptionMarkKind[optionMarkKind];
      isFormulaSelectiveType = true;
      if (optionRandomUse == 0) {
        valueOptionRandomUse = 'ランダム設定しない';
      } else {
        valueOptionRandomUse = 'ランダム設定する';
      }
    } else {
      titleOptionMarkKind = '記述文字数制限';
      if (inputLimitType) {
        valueOptionMarkKind = `${inputLimit}文字まで`;
      } else if (inputLimitType === false &&
        answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER) {
        valueOptionMarkKind = `${inputLimit}文字まで`;
      } else {
        valueOptionMarkKind = 'デフォルト(30文字まで)';
      }
    }
    if (!isShowConfirm || !answerInfo) {
      answerInfo = setDataSingleQuestion(answerFormula, optionArray, correctAnswer, correctNumber);
    }
    {/* Answer list */}
    ForEachArrayData = !isQuestionUseForm &&
    answerInfo &&
    answerInfo.length > 0 && (
    <div>
      <Form.Group className="form-info">
        <Col sm={12}>
          <Col sm={4} className="form-label">解答方式</Col>
          <Col sm={8} className="padding-top-bottom-10">{valueAnswerFormula}</Col>
        </Col>
      </Form.Group>
      <Form.Group className="form-info">
        <Col sm={12}>
          <Col sm={4} className="form-label" />
          <Col sm={3} className="padding-top-bottom-10">{titleOptionMarkKind}</Col>
          <Col sm={5} className="padding-top-bottom-10">{valueOptionMarkKind}</Col>
        </Col>
      </Form.Group>
      {titleOptionRandomUse &&
      <Form.Group className="form-info">
        <Col sm={12}>
          <Col sm={4} className="form-label" />
          <Col sm={3} className="padding-top-bottom-10">{titleOptionRandomUse}</Col>
          <Col sm={5} className="padding-top-bottom-10">{valueOptionRandomUse}</Col>
        </Col>
      </Form.Group>}
      <Form.Group className="form-info">
      <Col sm={12}>
          <Col sm={4} className="form-label" />
          <Col sm={8} className="padding-left-clear">
            <ContentSingleQuestionAnswerList
              answerInfo={answerInfo}
              answerFormula={answerFormula}
              isFormulaType={isFormulaSelectiveType}
              isShowDetail
            />
          </Col>
        </Col>
      </Form.Group>
    </div>
    );
  } else {
    ForEachArrayData =
      subQuestionArray &&
      subQuestionArray.map((subQuestionInfo, index) => (
        <div key={index}>
          <Form.Group className="form-info">
            <Col sm={12}>
              <Col sm={2} className="form-label">小問{parseInt(subQuestionInfo.subQuestionIndex, 10)}</Col>
              <Col sm={2} className="form-label">小問識別ID</Col>
              <Col sm={5} className="form-label">{subQuestionInfo.subQuestionSecernId}</Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12}>
              <Col sm={2} className="form-label" />
              <Col sm={2} className="form-label" >配点</Col>
              <Col sm={5} className="form-label" >{subQuestionInfo.subAbsolutePoint}点</Col>
            </Col>
          </Form.Group>
        </div>
      ));
  }
  return (
    <Col sm={12}>
      <Form className='form-horizontal'>
        {convertStatus === CONVERT_STATUS.CONVERSION_ERROR && convertErrorMessage ? (
          <Form.Group className="form-info textColorRed padding-left-15">
            <h3>変換に失敗しました。</h3>
            <h3>{`エラー要因：${convertErrorMessage}`}</h3>
          </Form.Group>
        ) : null}
        <Form.Group className="form-info">
          <Col sm={12}>
            <Col sm={4} className="form-label">問題形式</Col>
            <Col sm={8} className="padding-top-bottom-10">{titleQuestionKind}</Col>
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={12}>
            <Col sm={4} className="form-label">問題識別ID</Col>
            <Col sm={8} className="padding-top-bottom-10">{questionSecernId}</Col>
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={12}>
            <Col sm={4} className="form-label">問題タイトル</Col>
            <Col sm={8} className="padding-top-bottom-10">{valueQuestionTitle}</Col> {/* #6818 */}
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={12}>
            <Col sm={4} className="form-label">問題内容</Col>
            <Col sm={8} className="padding-top-bottom-10">{valueQuestionContent}</Col>
          </Col>
        </Form.Group>
        {ForEachArrayData}
        <Form.Group className="padding-left-5 margin-bottom-10 label-middle">
          <h3>詳細設定</h3>
        </Form.Group>
        {questionKind == 0 &&
        questionUseForm == 0 &&
          <Form.Group className="form-info">
            <Col sm={12}>
              <Col sm={4} className="form-label">表示方向指定</Col>
              <Col sm={8} className="padding-top-bottom-10">{arrayViewDirection[questionViewDirection]}</Col>
            </Col>
          </Form.Group>}
        {questionKind == 0 &&
          <Form.Group className="form-info">
            <Col sm={12}>
              <Col sm={4} className="form-label">配点</Col>
              <Col sm={8} className="padding-top-bottom-10">{absolutePoint ? `${absolutePoint}点` : 'なし'}</Col>
            </Col>
          </Form.Group>}
        <Form.Group className="form-info">
          <Col sm={12}>
            <Col sm={4} className="form-label">制限時間</Col>
            <Col sm={8} className="padding-top-bottom-10">{limitTime ? `${limitTime}秒` : 'なし'}</Col>
          </Col>
        </Form.Group>
        {questionKind == 0 &&
        <Form.Group className="form-info">
          <Col sm={12}>
            <Col sm={4} className="form-label">△判定</Col>
            <Col sm={8} className="padding-top-bottom-10">{arrayUseDistinct[sankakuUseDistinct]}</Col>
          </Col>
        </Form.Group>}
        <Form.Group className="form-info">
          <Col sm={12}>
            <Col sm={4} className="form-label">解答解説</Col>
            <Col sm={8} className="padding-top-bottom-10">{(valueExplanationContent && valueExplanationContent.length) ? valueExplanationContent : '使用しない'}</Col>
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={12}>
            <Col sm={4} className="form-label">ヒント</Col>
            <Col sm={8} className="padding-top-bottom-10">{(valueHintContent && valueHintContent.length) ? valueHintContent : '使用しない'}</Col>
          </Col>
        </Form.Group>
        { showQuestionAttributes &&
          <Form.Group className="form-info">
            <Col sm={12}>
              <Col sm={4} className="form-label">問題属性</Col>
              <Col sm={8} className="padding-left-clear">
                <Table striped hover>
                  <thead>
                    <TableHead data={thead} />
                  </thead>
                  <tbody>
                    {showQuestionAttributes}
                  </tbody>
                </Table>
              </Col>
            </Col>
          </Form.Group>
        }
      </Form>
      {!isPreview && isDetail !== false && (
        <Col sm={12} className="text-center margin-top-20">
          {showBackBtn && (
            <Button variant="primary" className="btn-96 margin-10" onClick={onBackBtnClick}>
              戻る
            </Button>
          )}
          {!dataAffiliationType && canAccess ? (
            <LinkContainer to={link} className="btn-96">
              <Button variant="primary" className="btn-96 margin-10">
                編集
              </Button>
            </LinkContainer>
          ) : null}
          {!dataAffiliationType && canAccess ? (
            <Button variant="primary" className="btn-96 margin-10" onClick={onDeleteBtnClick}>
              削除
            </Button>
          ) : null}
        </Col>
      )}
    </Col >
  );
};

export default ContentQuestionDetail;
